import { connect, MapDispatchToProps } from "react-redux";
import StudentsWaitListedComponent, {
  StudentsWaitListedProps,
} from "pages/StudentEnrolments/StudentsWaitlisted";
import { courseListRequest } from "store/course/actions";
import { studentWaitListedRequest } from "store/student/action";
import { approveWaitListedEnrolmentStatusRequest } from "store/studentEnrolment/actions";
import {
  IStudentWaitListContainerDispatch,
  IStudentWaitListed,
} from "utils/interfaces/student";

const mapDispatchToProps: MapDispatchToProps<
  IStudentWaitListContainerDispatch,
  IStudentWaitListed
> = {
  studentWaitListedRequest,
  courseListRequest,
  approveWaitListedEnrolmentStatusRequest,
};

const connector = connect(null, mapDispatchToProps);

const StudentWaitLists: React.FC<StudentsWaitListedProps> = (props) => {
  return <StudentsWaitListedComponent {...props} />;
};

export default connector(StudentWaitLists);
